import { Component } from '@angular/core';

@Component({
  selector: 'lib-store',
  imports: [],
  template: `
    <p>
      store works!
    </p>
  `,
  styles: ``
})
export class Store {

}
